<div *ngIf="!isMCQAnswered && post.forum_mcq_choices">
  <div class="mcq-options" *ngFor="let mcq_opt of mscqOptions; index as ind">
    <div class="btn btn-outline-info" style="border-radius: 50px;" (click)="optionClickEvent(ind+1)">
      <div class="mcq-opt-btn">
        <span>{{mcq_opt.option}}</span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isMCQAnswered">
  <div *ngFor="let mcq_opt of mscqOptions; index as ind">
    <div *ngIf="post.forum_mcq_answers != 0; else defaultMcq">
      <div [ngClass]="(ind+1 == post.forum_mcq_answers) ? 'btn-success correct-ans': (userSelectedMCQOption == ind+1+'') ? 'btn-danger wrong-ans': (ind+1 == post.forum_mcq_answers) ? 'btn-success correct-ans':'default-ans'"> <div class="opt-label">{{mcq_opt.option}}</div> <div class="opt-percentage">{{mcq_opt.percent}}</div></div>
    </div>
    <ng-template #defaultMcq>
      <div class="default-ans"> <div class="opt-label">{{mcq_opt.option}}</div> <div class="opt-percentage">{{mcq_opt.percent}}</div></div>
    </ng-template>
  </div>
  <!-- undo functionality added -->
  <!-- <div class="undo-btn">
    <div class="btn btn-light" (click)="undoOptionClickEvent()" style="border: 1px solid lightgray;">
      undo
    </div>
  </div> -->
</div>

<ng-container *ngIf="isMCQAnswered && post.forum_mcq_answers == 0">
    <span class="pl-3 text-warning">{{post.userName}} has not Answered this MCQ</span>
</ng-container>
